<template>
  <div class="actions">
    <b-button variant="primary" @click="startNewApplication" data-testid="start-new-application-button">
      <font-awesome-icon :icon="['fas', 'plus-circle']"/> Start a new application
    </b-button>   
  </div>
</template>

<script>
export default {
  name: 'RestartAppActions', 
  methods: {
    startNewApplication() {
      this.$store.dispatch('resetError')
      this.$router.history.push({
        name: 'WelcomeView'      
      })
    }
  }
}
</script>

<style scoped lang="scss">
.actions {
  margin-top: 3rem;
  span {
    font-size: 2rem;
    margin: 1rem;
  }
  button {
    margin: 1rem 0;
  }
}
</style>
